function initializeSelect2Basic(){
  if ($('.select2').length) {
    $('.select2').select2({})
  }
}

function initializeSelect2Employee(){
  if ($('.select2-employee').length) {
    $('.select2-employee').select2({          
      placeholder: 'Select | an | Employee',
      templateResult: function(data) {
        var r = data.text.split('|');
        var result = jQuery(
          '<div class="row">' +
              '<div class="col-md-4 py-0"><small>' + r[0] + '</small></div>' +
              '<div class="col-md-4 py-0"><small>' + r[1] + '</small></div>' +
              '<div class="col-md-4 py-0"><small>' + r[2] + '</small></div>' +
          '</div>'
        );
        return result;
      },
      templateSelection: function(data) {
        var r = data.text.split('|');
        var result = `${r[0]} - ${r[1]} - ${r[2]}`
        return result;
      }
    });

    $('.select2-employee').on('select2:open', function () {
      if ($('.select2-sticky-top').length === 0) {
        let stickyDiv = `
          <div class="row select2-sticky-top">
            <div class="col-4 py-0">Code</div>
            <div class="col-4 py-0">Name</div>
            <div class="col-4 py-0">Department</div>
          </div>
        `;
        $('.select2-results').prepend(stickyDiv);
      }
    });
  }
}

window.initializeSelect2 = function() {
  initializeSelect2Basic()
  initializeSelect2Employee()
};
